// extracted by mini-css-extract-plugin
export var chip = "_5g-0";
export var filterDropdown = "_5g-5";
export var filterItem = "_5g-6";
export var icon = "_5g-1";
export var removeButton = "_5g-3";
export var removeIcon = "_5g-4";
export var separator = "_5g-2";